var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "144.92 99.93 50.159 50.139",
    colorInterpolationFilters: "sRGB",
    viewBox: "144.419 99.429 51.163 51.143",
    height: 2399.059,
    width: 2400,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "ugc",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.92 99.93)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "image-rect",
    fill: "none",
    d: "M50.159 0v50.139H0V0h50.159z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    className: "image-svg-svg primary",
    height: 50.139,
    width: 50.159,
    filter: "url(#b43a4b8f-140a-41fc-9340-b1605a96d3b7_comp-lt62fn1e)",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "9.967 9.991 80.042 80.01",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.99 14.27c19.729 9.94 27.67 33.98 17.74 53.72l-7.521-7.79c5.64-15.58-2.43-32.78-18.01-38.41-.312-.12-.92-.32-1.24-.42l-5.33-2.05 2.91 3.35 21.67 37.53 6.04 10.46c-.75 1.31-2.4 3.64-3.39 4.779-14.052 17.051-39.262 19.48-56.302 5.42l3.102-10.829c11.06 12.329 30.029 13.37 42.37 2.31.63-.55 1.76-1.68 2.31-2.31L66.55 60H36.36l2.87-10h20.229l2.61.75-1.95-1.89-9.46-16.38-.66-2.64-.66 2.64L39.23 50 27.66 70.03l-5.19 8.989C9.821 67.77 6.18 46.88 14.27 32.01c9.94-19.73 33.98-27.67 53.72-17.74zm-24.53 8.4 2.91-3.35-5.33 2.05C26.26 25.83 17.2 41.53 20.72 56.55l.892 5.65L23.06 58l20.4-35.33z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b43a4b8f-140a-41fc-9340-b1605a96d3b7_comp-lt62fn1e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    className: "icon-feColorMatrix",
    values: "0 0 0 0 0.71875 0 0 0 0 0.375 0 0 0 0 0.8984375 0 0 0 1 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0402bb51604343c8f2d13205175a9b39.svg";
export { ForwardRef as ReactComponent };